export const IconProductBox = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 16V8a2 2 0 0 0-1-1.73L13 2.27a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4a2 2 0 0 0 1-1.73z" stroke="#262626" fill="none" />
            <path d="M3.27 6.96L12 12.01l8.73-5.05" stroke="#262626" fill="none" />
            <path d="M12 22.08V12" stroke="#262626" fill="none" />
        </svg>
    )
}